import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';

const UNDISCLOSED_ADDRESS = '(Undisclosed Address)';

export const useListingName = (): string => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const address = listing?.address;

  if (address?.hideStreet) {
    const locality = [address.city, address.state].filter(Boolean).join(', ');
    return locality ? `${UNDISCLOSED_ADDRESS}, ${locality}` : UNDISCLOSED_ADDRESS;
  }

  return (
    (listing as unknown as { propertyName?: string })?.propertyName ||
    (listing as unknown as { displayName?: string })?.displayName ||
    address?.street ||
    ''
  );
};
